import { render, staticRenderFns } from "./chatroom-private.vue?vue&type=template&id=696a20e8&scoped=true"
import script from "./chatroom-private.vue?vue&type=script&lang=js"
export * from "./chatroom-private.vue?vue&type=script&lang=js"
import style0 from "./chatroom-private.vue?vue&type=style&index=0&id=696a20e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a20e8",
  null
  
)

export default component.exports